"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapCatalogs = void 0;
var mapCatalogs = exports.mapCatalogs = function mapCatalogs(catalogs, currentValue) {
  var mappedCatalogs = {};
  catalogs.forEach(function (catalog) {
    mappedCatalogs[catalog.id] = catalog.values.filter(function (el) {
      return el.active || el.external_id === currentValue;
    }).map(function (el) {
      return {
        value: el.external_id,
        label: el.label
      };
    });
  });
  return mappedCatalogs;
};